var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;opacity:0.01;}.cls-2,.cls-3{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.cls-2{stroke:#475867;}.cls-3{stroke:#00a886;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "White_BG",
    "data-name": "White BG"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 64,
    height: 64
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Artwork"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 20.96,
    cy: 22.89,
    r: 7.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.05,51A15.91,15.91,0,0,1,22,35.12c8.45.55,14.84,8,14.84,16.42V55.8A3.18,3.18,0,0,1,33.68,59H8.23A3.18,3.18,0,0,1,5.05,55.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M37.86,23.4A11.63,11.63,0,1,1,40.38,26l-4,1.49Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 47.43,
    y1: 11.11,
    x2: 47.43,
    y2: 17.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 47.43,
    y1: 20.75,
    x2: 47.43,
    y2: 21.75
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.d5fcf5ab4c38f05a5df25e64b31eddde.svg";
export { ForwardRef as ReactComponent };